import { ctaLinkProps } from '#/domains/landing/utils/ctaLink';
import ShareButton from './ShareButton';

interface StickyCTAProps {
  label: string;
  href?: string;
  onClick?: () => void;
  showShare?: boolean;
  shareUrl?: string;
  trackingEventKey?: string;
}

export default function StickyCTA({
  label,
  href,
  onClick,
  showShare = false,
  shareUrl,
  trackingEventKey,
}: StickyCTAProps) {
  const { href: finalHref, onClick: trackCtaClick } = ctaLinkProps(
    href,
    trackingEventKey
  );

  const handleCtaClick = () => {
    trackCtaClick();
    onClick?.();
  };

  const ctaClassName =
    'flex h-14 min-h-px min-w-px flex-1 cursor-pointer items-center justify-center gap-1.5 overflow-hidden rounded-[18px] bg-blue-55 px-4 transition-colors active:bg-blue-50';

  return (
    <div className="fixed bottom-0 left-1/2 z-50 w-full max-w-[640px] -translate-x-1/2 rounded-t-[28px] border-t border-black/[0.04] bg-white shadow-[0px_2px_10px_0px_rgba(18,21,25,0.06)]">
      <div className="flex w-full items-center gap-3 px-5 pb-6 pr-4 pt-5">
        {finalHref ? (
          <a
            id="btn-sticky-cta"
            href={finalHref}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleCtaClick}
            className={ctaClassName}
          >
            <span className="text-base font-bold leading-[1.5] text-white">
              {label}
            </span>
          </a>
        ) : (
          <button
            id="btn-sticky-cta"
            type="button"
            onClick={handleCtaClick}
            className={ctaClassName}
          >
            <span className="text-base font-bold leading-[1.5] text-white">
              {label}
            </span>
          </button>
        )}
        {showShare && (
          <ShareButton
            id="btn-share"
            shareUrl={shareUrl}
            ariaLabel="Share"
            iconSize={22}
            iconClassName="opacity-60"
            className="flex h-14 w-14 shrink-0 cursor-pointer items-center justify-center rounded-[18px] border border-gray-15 bg-white transition-colors active:bg-gray-5"
          />
        )}
      </div>
    </div>
  );
}
